import styled from 'styled-components';

export const RightContainerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 20px;
`;

export const UserGuideWrapper = styled.a`
  color: white;
  font-size: 40px;
`;
